module.exports = __webpack_public_path__ + "static/media/3pl1.519fa4af.png";